import { ProductClassFormState } from '../index'

export default function validateForm( formState: ProductClassFormState ): { isInvalid: boolean, newFormState: ProductClassFormState } {
	const newFormState = { ...formState }
	let isInvalid = false

	if ( formState.catClass === '' ) {
		isInvalid = true
		newFormState.validation.catClass = {
			isInvalid: true,
			error: 'CAT/CLASS number is required',
		}
	} else {
		newFormState.validation.catClass = { isInvalid: false }
	}

	if ( formState.categoryName === '' ) {
		isInvalid = true
		newFormState.validation.categoryName = {
			isInvalid: true,
			error: 'Category name is required',
		}
	} else {
		newFormState.validation.categoryName = { isInvalid: false }
	}

	if ( formState.classification === '' ) {
		isInvalid = true
		newFormState.validation.classification = {
			isInvalid: true,
			error: 'Classification is required',
		}
	} else {
		newFormState.validation.classification = { isInvalid: false }
	}

	return {
		isInvalid,
		newFormState
	}
}
